import { Button, Box } from "@mui/material";
import theme from "../theme/Theme";


const CustomButton = ({ title, onClick, icon }) => {
    return (
        <Box sx={styles.buttonWrapper}>
            <Button
                sx={styles.buttonContainer}
                onClick={onClick}
                startIcon={icon ? <Box sx={styles.iconContainer}>{icon}</Box> : null}
            >
                {title}
            </Button>
        </Box>
    );
};

export default CustomButton;

const styles = {
    buttonWrapper: {
        display: "flex", // Ensures proper alignment
        alignItems: "center", // Centers content vertically
        justifyContent: "center", // Centers content horizontally
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: "12px",
        padding: { xs: "0.2em", lg: "0.3em" }, // Increased padding to match height
        "&:hover": {
            cursor: "pointer",
        },
    },
    buttonContainer: {
        background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        padding: { xs: "0.5em 1em", lg: "0.7em 1.5em" },
        borderRadius: "10px",
        color: "white",
        fontSize: "0.7rem",
        fontWeight: "600",
        textTransform: "uppercase",
        minHeight: "40px",
        minWidth: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    iconContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        marginRight: "8px",
        border: "2px solid black",
    },
};

